export class CCError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
  }
}

export function classifyError(msg = "") {
  if (/out of memory|oom|allocat|memory|bad_alloc|RangeError/i.test(msg)) return "OOM";
  if (/fetch|network|404|load failed|NetworkError|Failed to import|dynamically imported/i.test(msg)) return "NETWORK";
  if (/webgpu|gpu|adapter|shader|device lost/i.test(msg)) return "GPU";
  return "UNKNOWN";
}

export const ERROR_HELP = {
  NO_SPEECH: { title: "No speech detected", tip: "The audio seems silent or contains only music/noise. Nothing was captioned — no fake captions are added." },
  NO_AUDIO: { title: "This video has no audio track", tip: "Upload a video that contains spoken audio." },
  DECODE: { title: "Could not read the audio", tip: "Your browser could not decode this file. Try converting it to MP4 (H.264 + AAC) and upload again." },
  OOM: { title: "Device ran out of memory", tip: "Try a smaller model (Small, Base or Tiny), close other tabs, or use a shorter video." },
  NETWORK: { title: "Model download interrupted", tip: "Check your internet connection and tap Retry. Already downloaded files are cached." },
  GPU: { title: "WebGPU failed on this device", tip: "Turn on 'Force CPU mode' and use Whisper Small, then retry." },
  WORKER: { title: "The transcription engine crashed", tip: "This usually means the browser ran out of memory. Try a smaller model or shorter video." },
  CANCELLED: { title: "Transcription stopped", tip: "You can start again any time." },
  UNKNOWN: { title: "Transcription failed", tip: "Tap Retry. If it fails again, try a smaller model." },
};
